var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PtrSearch',{staticClass:"pointr-search",attrs:{"search-results":_vm.searchResultsAsText,"search-results-details":_vm.searchResultsDetails,"auto-search-length":3,"is-loading":_vm.isLoading},on:{"searched":_vm.search,"cleared":_vm.cleared,"result-selected":_vm.resultSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }